/**
 * @flow
 * @relayHash 99970ac544efbb67b5767d68444303ab
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type generalLeaderboardSubscriptionVariables = {|
  event_id: string
|};
export type generalLeaderboardSubscriptionResponse = {|
  +updateGeneralLeaderboard: ?{|
    +event_id: ?number
  |}
|};
export type generalLeaderboardSubscription = {|
  variables: generalLeaderboardSubscriptionVariables,
  response: generalLeaderboardSubscriptionResponse,
|};
*/


/*
subscription generalLeaderboardSubscription(
  $event_id: ID!
) {
  updateGeneralLeaderboard(event_id: $event_id) {
    event_id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateGeneralLeaderboard",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event_id",
        "variableName": "event_id"
      }
    ],
    "concreteType": "updateGeneralLeaderboardType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "event_id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "generalLeaderboardSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "generalLeaderboardSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "generalLeaderboardSubscription",
    "id": null,
    "text": "subscription generalLeaderboardSubscription(\n  $event_id: ID!\n) {\n  updateGeneralLeaderboard(event_id: $event_id) {\n    event_id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5f8ef0d18e3d99820016bcb7f37e566';
module.exports = node;
